const WUR_REPORTER_INTERIM_ACTIONS = [
  'wurReporterInterim:viewRelease',
  'wurReporterInterim:download',
];

const WUR_REPORTER_INTERIM_ACTIONS_WITHOUT_YEAR = [
  'wurReporterInterim:addScenario',
  'wurReporterInterim:viewScenario',
  'wurReporterInterim:editScenario',
  'wurReporterInterim:archiveScenario',
  'wurReporterInterim:viewPage',
];

module.exports = {
  WUR_REPORTER_INTERIM_ACTIONS,
  WUR_REPORTER_INTERIM_ACTIONS_WITHOUT_YEAR,
};
